var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map, List } from 'immutable';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import * as actions from "../actions/actions";

import LeftRelationship from "./LeftRelationship";
import RightRelationship from "./RightRelationship";

export class RelationshipsGraphEdit extends Component {
  componentDidMount() {
    this.props.parseResults(this.props.searchResults, this.props.parentEntity, this.props.editing);
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchResults !== prevProps.searchResults) {
      this.props.parseResults(
        this.props.searchResults,
        this.props.parentEntity,
        this.props.editing
      );
    }
  }

  render() {
    const { hubs, addHub } = this.props;

    return /*#__PURE__*/(
      _jsx("div", { className: "relationships-graph" }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0,
      hubs.map((hub, index) => /*#__PURE__*/
      _jsx("div", { className: "relationshipsHub" }, index, /*#__PURE__*/
      _jsx(LeftRelationship, { index: index, hub: hub }), /*#__PURE__*/
      _jsx(RightRelationship, { index: index, hub: hub })
      )
      ),

      this.props.editing && /*#__PURE__*/
      _jsx("div", { className: "relationshipsHub" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "leftRelationshipType " }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "relationships-new", onClick: addHub }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "New relationships group")
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "plus" })
      )
      )
      )

      )
      ));

  }
}










export function mapStateToProps(state) {
  const { relationships } = state;
  return {
    parentEntity: relationships.list.entity,
    searchResults: relationships.list.searchResults,
    search: relationships.list.sort,
    hubs: relationships.hubs,
    editing: relationships.hubActions.get('editing')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      parseResults: actions.parseResults,
      addHub: actions.addHub
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RelationshipsGraphEdit);